module.exports = __webpack_public_path__ + "img/weddings_06_V.67e651ae.webp";